(function(){
  var T = null, vue = null, R = window.MDS || {};
  var prets = {};
  function preparer(src, detour){
    var k = src + "|" + detour;
    if (prets[k]) return prets[k];
    prets[k] = new Promise(function(ok){
      var im = new Image(); im.crossOrigin = "anonymous";
      im.onload = function(){
        try {
          var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement("canvas"); c.width = w; c.height = h;
          var x = c.getContext("2d", {willReadFrequently: true}); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y += 2) for (var xx = 0; xx < w; xx += 2){ var i = (y * w + xx) * 4; if (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236){ if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
          if (x1 < 0){ ok({tex: src, pied: 0, teinte: null}); return; }
          x1 = Math.min(w - 1, x1 + 2); y1 = Math.min(h - 1, y1 + 2);
          var cw = x1 - x0 + 1, ch = y1 - y0 + 1, k2 = Math.min(1, 1600 / Math.max(cw, ch));
          var c2 = document.createElement("canvas"); c2.width = Math.round(cw * k2); c2.height = Math.round(ch * k2);
          var x2 = c2.getContext("2d", {willReadFrequently: true}); x2.drawImage(c, x0, y0, cw, ch, 0, 0, c2.width, c2.height);
          var W = c2.width, H = c2.height, img = x2.getImageData(0, 0, W, H), p = img.data, vide = 0, s = [0, 0, 0, 0];
          if (detour){
            for (var j = 0; j < p.length; j += 4) if (p[j] > 236 && p[j + 1] > 236 && p[j + 2] > 236) p[j + 3] = 0;
            x2.putImageData(img, 0, 0);
            for (var yy = H - 1; yy > H * 0.5; yy--){ var n = 0, t = 0; for (var xa = Math.floor(W * 0.3); xa < W * 0.7; xa += 3){ t++; if (p[(yy * W + xa) * 4 + 3] === 0) n++; } if (n > t * 0.7) vide++; else break; }
          }
          for (var yb = Math.floor(H * .25); yb < H * .75; yb += 7) for (var xb = Math.floor(W * .1); xb < W * .9; xb += 7){ var q = (yb * W + xb) * 4; if (p[q + 3] && p[q] > 60 && p[q] < 235 && p[q] > p[q + 2] + 25){ s[0] += p[q]; s[1] += p[q + 1]; s[2] += p[q + 2]; s[3]++; } }
          ok({tex: c2, pied: vide / H, teinte: s[3] ? [Math.round(s[0] / s[3]), Math.round(s[1] / s[3]), Math.round(s[2] / s[3])] : null});
        } catch(e){ ok({tex: src, pied: 0, teinte: null}); }
      };
      im.onerror = function(){ ok(null); };
      im.src = src;
    });
    return prets[k];
  }
  function sourceTex(p){ if (p.famille !== "tapis" && window.MDS3D && window.MDS3D.fiche && window.MDS3D.fiche(p.nom)) return "";
    if (p.tex_c){
      var cc = document.querySelector("[data-coloris][aria-pressed=true]"), cle = cc && cc.getAttribute("data-coloris");
      if (cle && p.tex_c[cle]) return p.tex_c[cle];
      for (var c in p.tex_c) if (p.tex_c[c]) return p.tex_c[c];
    }
    return p.tex || "";
  }
  function pret(p){
    var src = sourceTex(p);
    if (!src) return Promise.resolve(null);
    return preparer(src, p.famille !== "tapis").then(function(r){
      if (r && p.auto && p.famille !== "tapis"){
        p.pied = Math.round(r.pied * p.h * 10) / 10;
        if (r.teinte) p.teinte = r.teinte;
      }
      vue = vue || {}; vue.faits = vue.faits || {}; vue.faits[src] = r || {tex: null};
      return r;
    });
  }
  function charger(){
    if (T) return Promise.resolve(T);
    return Promise.all([
      (window.MDSImport = window.MDSImport || new Function("u", "return import(u)"))("https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js"),
      (window.MDSImport = window.MDSImport || new Function("u", "return import(u)"))("https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/controls/OrbitControls.js"),
      (window.MDSImport = window.MDSImport || new Function("u", "return import(u)"))("https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/environments/RoomEnvironment.js")
    ]).then(function(m){ T = {THREE: m[0], Orbit: m[1].OrbitControls, Room: m[2].RoomEnvironment}; return T; });
  }

  function largeurReelle(p){
    var t = window.PRODUIT && window.PRODUIT.tailles && document.querySelector("[data-choix-taille][aria-pressed=true]");
    if (!t) return p.l;
    var n = parseFloat(t.getAttribute("data-choix-taille"));
    if (p.famille === "lits") return n + 8;
    if (p.famille === "tapis"){ var dd = t.getAttribute("data-choix-taille").split(" x "); p.p = parseFloat(dd[1]); return parseFloat(dd[0]); }
    if (p.famille === "tables") return n;
    return p.l;
  }

  function fenetre(){
    var d = document.createElement("div");
    d.className = "wall-viewer"; d.setAttribute("role", "dialog"); d.setAttribute("aria-modal", "true"); d.hidden = true;
    d.innerHTML = '<div class="wall-viewer__dialog"><div class="wall-viewer__header"><div><b data-m3-titre></b><span>Tournez la scène avec la souris ou le doigt.</span></div><button type="button" class="wall-viewer__close" aria-label="Fermer"><i class="ph ph-x"></i></button></div>' +
      '<div class="wall-viewer__scene"><canvas></canvas><p class="wall-viewer__verdict" data-m3-verdict></p><p class="wall-viewer__loading" data-m3-charge>Chargement de la pièce…</p></div>' +
      '<div class="wall-viewer__controls"><label>Largeur de votre mur<span class="wall-viewer__stepper"><button type="button" data-m3="-5" aria-label="Moins 5 cm">−</button><input type="number" inputmode="numeric" min="80" max="600" step="5" data-m3-mur><span>cm</span><button type="button" data-m3="5" aria-label="Plus 5 cm">+</button></span></label>' +
      '<label>Hauteur sous plafond<span class="wall-viewer__stepper"><button type="button" data-m3h="-5" aria-label="Moins 5 cm">−</button><input type="number" inputmode="numeric" min="200" max="400" step="5" value="250" data-m3-plafond><span>cm</span><button type="button" data-m3h="5" aria-label="Plus 5 cm">+</button></span></label>' +
      '<p class="wall-viewer__note">Mesurez d\'une plinthe à l\'autre. La silhouette mesure 1,75&nbsp;m.</p></div></div>';
    document.body.appendChild(d);
    d.addEventListener("click", function(e){
      if (e.target === d || e.target.closest(".wall-viewer__close")) fermer();
      var b = e.target.closest("[data-m3]"), h = e.target.closest("[data-m3h]");
      if (b){ var i = d.querySelector("[data-m3-mur]"); i.value = Math.max(80, Math.min(600, (+i.value || 0) + (+b.getAttribute("data-m3")))); majBientot(); }
      if (h){ var j = d.querySelector("[data-m3-plafond]"); j.value = Math.max(200, Math.min(400, (+j.value || 0) + (+h.getAttribute("data-m3h")))); majBientot(); }
    });
    d.querySelector("[data-m3-mur]").addEventListener("input", majBientot);
    d.querySelector("[data-m3-plafond]").addEventListener("input", majBientot);
    document.addEventListener("keydown", function(e){ if (e.key === "Escape" && !d.hidden) fermer(); });
    return d;
  }

  var dlg = null, avant = null;
  function ouvrir(p){
    dlg = dlg || fenetre();
    avant = document.activeElement;
    vue = vue || {};
    vue.p = p; vue.l = largeurReelle(p); vue.cadrer = true;
    dlg.querySelector("[data-m3-titre]").textContent = p.nom + (p.famille === "tapis" ? " dans votre salon" : " sur votre mur");
    var mur = dlg.querySelector("[data-m3-mur]");
    mur.value = Math.ceil((vue.l + 60) / 5) * 5;
    dlg.hidden = false; document.body.classList.add("has-open-wall-viewer");
    requestAnimationFrame(function(){ dlg.classList.add("is-open"); });
    dlg.querySelector(".wall-viewer__close").focus({preventScroll:true});
    Promise.all([charger(), pret(p)]).then(function(r){ dlg.querySelector("[data-m3-charge]").hidden = true; construire(r[0]); maj(); })
      .catch(function(e){ if (window.console) console.error("wall-viewer", e); dlg.querySelector("[data-m3-charge]").textContent = "La vue 3D ne se charge pas sur cet appareil. Écrivez-nous avec une photo de votre mur, réponse le jour même."; });
  }
  function fermer(){
    dlg.classList.remove("is-open"); document.body.classList.remove("has-open-wall-viewer");
    setTimeout(function(){ dlg.hidden = true; }, 250);
    if (vue && vue.stop) vue.stop();
    if (avant) avant.focus({preventScroll:true});
  }

  function construire(t){
    var THREE = t.THREE, canvas = dlg.querySelector("canvas"), scene = dlg.querySelector(".wall-viewer__scene");
    if (!vue.renderer){
      var r = new THREE.WebGLRenderer({canvas: canvas, antialias: true, alpha: false});
      r.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
      r.shadowMap.enabled = true; r.shadowMap.type = THREE.PCFSoftShadowMap;
      r.outputColorSpace = THREE.SRGBColorSpace; r.toneMapping = THREE.ACESFilmicToneMapping; r.toneMappingExposure = 0.92;
      var sc = new THREE.Scene(); sc.background = new THREE.Color(0xF4F2EE);
      var pm = new THREE.PMREMGenerator(r); sc.environment = pm.fromScene(new t.Room(), 0.04).texture;
      var cam = new THREE.PerspectiveCamera(38, 1, 0.05, 50);
      var ctrl = new t.Orbit(cam, canvas);
      ctrl.enableDamping = true; ctrl.enablePan = false; ctrl.minDistance = 1.2; ctrl.maxDistance = 8;
      ctrl.minPolarAngle = 0.35; ctrl.maxPolarAngle = 1.5; ctrl.minAzimuthAngle = -1.1; ctrl.maxAzimuthAngle = 1.1;
      sc.add(new THREE.HemisphereLight(0xffffff, 0xd9cfc4, 0.45));
      var sol = new THREE.DirectionalLight(0xfff4e6, 1.25); sol.position.set(-2.5, 4, 4); sol.castShadow = true;
      sol.shadow.mapSize.set(2048, 2048); sol.shadow.camera.left = -5; sol.shadow.camera.right = 5; sol.shadow.camera.top = 5; sol.shadow.camera.bottom = -2; sol.shadow.radius = 4;
      sc.add(sol);
      vue.renderer = r; vue.scene = sc; vue.cam = cam; vue.ctrl = ctrl; vue.groupe = new THREE.Group(); sc.add(vue.groupe);
      var ro = new ResizeObserver(function(){ var w = scene.clientWidth, h = scene.clientHeight; r.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); });
      ro.observe(scene);
    }
    var actif = true;
    vue.stop = function(){ actif = false; };
    (function boucle(){ if (!actif) return; vue.ctrl.update(); vue.renderer.render(vue.scene, vue.cam); requestAnimationFrame(boucle); })();
  }

  var majPrevue = 0;
  function majBientot(){ if (majPrevue) return; majPrevue = requestAnimationFrame(function(){ majPrevue = 0; maj(); }); }

  function maj(){
    if (!vue || !vue.renderer || !T) return;
    var THREE = T.THREE, g = vue.groupe, p = vue.p;
    var srcTex = sourceTex(p), prepa = srcTex ? (vue.faits || {})[srcTex] : null;
    if (srcTex && !prepa){ pret(p).then(maj); return; }
    for (var n = g.children.length - 1; n >= 0; n--){ var c = g.children[n]; if (c === vue.meuble) continue; g.remove(c); if (c.geometry && c !== vue.homme) c.geometry.dispose(); }
    var mur = Math.max(80, +dlg.querySelector("[data-m3-mur]").value || 0) / 100;
    var plafond = Math.max(200, +dlg.querySelector("[data-m3-plafond]").value || 250) / 100;
    var L = vue.l / 100, H = p.h / 100, P = p.p / 100, table = p.famille === "tables";
    var pieceW = 14;
    if (!vue.mats) vue.mats = {
      mur: new THREE.MeshStandardMaterial({color: 0xF3EFEA, roughness: 1}),
      plinthe: new THREE.MeshStandardMaterial({color: 0xFFFFFF, roughness: .8}),
      sol: new THREE.MeshStandardMaterial({color: 0xCDBBA4, roughness: .9}),
      bord: new THREE.MeshBasicMaterial({color: 0x9A4528})
    };
    var murG = new THREE.Mesh(new THREE.PlaneGeometry(pieceW, plafond), vue.mats.mur);
    murG.position.set(0, plafond / 2, 0); murG.receiveShadow = true; g.add(murG);
    var plinthe = new THREE.Mesh(new THREE.BoxGeometry(mur, 0.06, 0.012), vue.mats.plinthe);
    plinthe.position.set(0, 0.03, 0.006); g.add(plinthe);
    var sol = new THREE.Mesh(new THREE.PlaneGeometry(pieceW, 10), vue.mats.sol);
    sol.rotation.x = -Math.PI / 2; sol.position.set(0, 0, 5); sol.receiveShadow = true; g.add(sol);
    var bord = vue.mats.bord;
    [-mur / 2, mur / 2].forEach(function(x){ var b = new THREE.Mesh(new THREE.BoxGeometry(0.01, plafond, 0.004), bord); b.position.set(x, plafond / 2, 0.003); g.add(b); var r = new THREE.Mesh(new THREE.BoxGeometry(0.01, 0.002, 1.2), bord); r.position.set(x, 0.002, 0.6); g.add(r); });
    if (!vue.grain && window.MDS3D_GRAIN){ vue.grain = new THREE.TextureLoader().load(window.MDS3D_GRAIN); vue.grain.colorSpace = THREE.SRGBColorSpace; }
    var aTex = !!(prepa && prepa.tex);
    if (aTex && vue.texSrc !== srcTex){
      vue.tex = typeof prepa.tex === "string" ? new THREE.TextureLoader().load(prepa.tex) : new THREE.CanvasTexture(prepa.tex);
      vue.tex.colorSpace = THREE.SRGBColorSpace; vue.tex.anisotropy = vue.renderer.capabilities.getMaxAnisotropy(); vue.texSrc = srcTex;
    }
    var cleMeuble = p.nom + "|" + L + "|" + (aTex ? srcTex : "");
    if (vue.cleMeuble !== cleMeuble){
      if (vue.meuble) g.remove(vue.meuble);
      var meuble = (p.famille !== "tapis" && window.MDS3D.modeleNeuf && window.MDS3D.modeleNeuf(THREE, p, L)) || window.MDS3D.modele(THREE, p, L, {grain: vue.grain, face: aTex ? vue.tex : null});
      if (table) meuble.position.z = 0.9;
      window.MDS3D.dernier = meuble;
      vue.meuble = meuble; vue.cleMeuble = cleMeuble;
      g.add(meuble);
    }
    if (p.famille === "tapis") H = 0.9;
    if (!vue.silhouette){
      var cv = document.createElement("canvas"); cv.width = 180; cv.height = 700; var x = cv.getContext("2d");
      x.fillStyle = "#8C8781";
      x.beginPath(); x.arc(90, 46, 40, 0, Math.PI * 2); x.fill();
      x.beginPath(); x.moveTo(36, 120); x.quadraticCurveTo(90, 98, 144, 120); x.lineTo(162, 360); x.lineTo(136, 366); x.lineTo(126, 220); x.lineTo(124, 690); x.lineTo(94, 690); x.lineTo(90, 420); x.lineTo(86, 690); x.lineTo(56, 690); x.lineTo(54, 220); x.lineTo(44, 366); x.lineTo(18, 360); x.closePath(); x.fill();
      var tx = new THREE.CanvasTexture(cv); tx.colorSpace = THREE.SRGBColorSpace;
      vue.silhouette = new THREE.MeshBasicMaterial({map: tx, transparent: true, opacity: .55, depthWrite: false});
    }
    var homme = vue.homme = vue.homme || new THREE.Mesh(new THREE.PlaneGeometry(0.45, 1.75), vue.silhouette);
    var px = Math.max(mur / 2, L / 2) + 0.45;
    homme.position.set(px, 0.875, 0.2); g.add(homme);
    var reste = Math.round((mur - L) * 100);
    var v = dlg.querySelector("[data-m3-verdict]");
    var plafondOk = H < plafond;
    v.className = "wall-viewer__verdict " + (reste >= 0 && plafondOk ? "wall-viewer__verdict--fits" : "wall-viewer__verdict--warning");
    var cote = (reste / 2).toString().replace(".", ",") + " cm";
    if (table && reste >= 0 && reste < 160){ v.className = "wall-viewer__verdict wall-viewer__verdict--warning"; v.innerHTML = "<b>Juste</b> : " + cote + " de chaque côté. Comptez 80 cm pour reculer une chaise."; }
    else v.innerHTML = !plafondOk ? "<b>Trop haut</b> pour votre plafond." : reste < 0 ? "<b>Trop large de " + (-reste) + " cm</b> pour ce mur." : "<b>Il rentre</b> : " + cote + " libres de chaque côté.";
    var tanV = Math.tan(vue.cam.fov * Math.PI / 360), scn = dlg.querySelector(".wall-viewer__scene"), aspect = (scn.clientWidth / scn.clientHeight) || vue.cam.aspect || 1;
    var largeurVue = Math.max(L, Math.min(mur, L + 0.8)) + 0.4, cible = new THREE.Vector3(0, Math.min(1.1, H * 0.65 + 0.2), table ? 0.9 : 0);
    var hauteurVue = 2 * Math.max(cible.y, H + 0.15 - cible.y) + 0.4;
    var dist = Math.min(7.5, Math.max(2.4, hauteurVue / 2 / tanV, largeurVue / 2 / (tanV * aspect)) * 1.08);
    var dir = new THREE.Vector3(0.32, (Math.min(2.2, H + 0.9) - cible.y) / dist, 1);
    if (p.famille === "tapis"){ cible.set(0, 0.2, 0.55 + P / 2); dir.set(0.8, 2.9, 1.85 + P / 2); dist = Math.min(7.5, Math.max(3.4, (P + 1.2) / 2 / (tanV * Math.min(1, aspect)) * 0.9)); }
    if (vue.cadrer){ vue.cadrer = false; vue.ctrl.target.copy(cible); }
    else dir.copy(vue.cam.position).sub(vue.ctrl.target);
    vue.cam.position.copy(vue.ctrl.target).add(dir.normalize().multiplyScalar(dist));
    vue.ctrl.update();
  }

  var mv = null, tactile = window.matchMedia("(pointer: coarse)").matches;
  function nomAR(id){
    var p = (window.MEUBLES3D || {})[id]; if (!p) return "";
    var suffixe = window.PRODUIT && window.PRODUIT.tailles ? "-" + Math.round(largeurReelle(p)) : "";
    return id + suffixe + ".glb";
  }
  var trouves = {};
  function existe(u){ return fetch(u, {method: "HEAD"}).then(function(r){ return r.ok; }).catch(function(){ return false; }); }
  function fichierAR(id){
    var nom = nomAR(id); if (!nom) return Promise.resolve("");
    if (trouves[nom] !== undefined) return Promise.resolve(trouves[nom]);
    var theme = (R.glbTheme || "") + nom, fichiers = (R.glbFichiers || "") + nom;
    var ordre = R.sourceGlb === "fichiers" ? [fichiers, theme] : [theme, fichiers];
    return existe(ordre[0]).then(function(ok){ return ok ? ordre[0] : (R.glbFichiers ? existe(ordre[1]).then(function(ok2){ return ok2 ? ordre[1] : ""; }) : ""); })
      .then(function(u){ trouves[nom] = u; return u; });
  }
  function prepareAR(){
    var b = document.querySelector("[data-voir-ar]"); if (!b || !tactile) return;
    fichierAR(b.getAttribute("data-voir-ar")).then(function(u){
      if (!u) throw new Error("glb");
      return (window.MDSImport = window.MDSImport || new Function("u", "return import(u)"))("https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js").then(function(){ return u; });
    }).then(function(u){
      mv = document.createElement("model-viewer");
      mv.setAttribute("ar", ""); mv.setAttribute("ar-modes", "webxr scene-viewer quick-look"); mv.setAttribute("ar-scale", "fixed"); mv.setAttribute("ar-placement", "floor");
      mv.setAttribute("alt", b.getAttribute("data-nom") || "Meuble en 3D"); mv.setAttribute("src", u);
      mv.className = "wall-viewer__ar-model";
      document.body.appendChild(mv);
      document.querySelectorAll("[data-voir-ar]").forEach(function(x){ x.hidden = false; });
    }).catch(function(){});
  }
  document.addEventListener("click", function(e){
    if (e.target.closest("[data-choix-taille]") && mv){ var b0 = document.querySelector("[data-voir-ar]"); setTimeout(function(){ fichierAR(b0.getAttribute("data-voir-ar")).then(function(u){ if (u) mv.setAttribute("src", u); }); }, 50); }
    var a = e.target.closest("[data-voir-ar]");
    if (a){
      e.preventDefault();
      if (mv && mv.canActivateAR){ mv.activateAR(); return; }
      var q = (window.MEUBLES3D || {})[a.getAttribute("data-voir-ar")]; if (q) ouvrir(q);
      return;
    }
    var b = e.target.closest("[data-voir-3d]"); if (!b) return;
    e.preventDefault();
    var id = b.getAttribute("data-voir-3d"), p = (window.MEUBLES3D || {})[id];
    if (p) ouvrir(p);
  });
  if (document.readyState === "complete") setTimeout(prepareAR, 1500); else window.addEventListener("load", function(){ setTimeout(prepareAR, 1500); });
})();
